import PageTitle from "../Components/PageTitle";
import Seo from "../Components/Seo";

export default function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-4xl rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100">
      <Seo
        title="Privacy Policy"
        description="Read the Calm Coast Hypnotherapy privacy policy and how personal information is handled."
        path="/privacy-policy"
      />
      <PageTitle title={"Privacy Policy"} />

      <div className="space-y-4 text-slate-700">
        <p>
          Calm Coast Hypnotherapy respects your privacy and is committed to protecting your personal information.
        </p>
        <p>
          Contact email: calmcoasthypnotherapy@hotmail.com
        </p>
        <p>
          Full privacy policy details (data controller details, lawful basis, retention and rights) will be added
          before launch.
        </p>
      </div>
    </div>
  )
}